import { IMutationRef } from "actions/mutate";
import { IServerDimensionPreference } from "helpers/door-collection";
import { IItemDisplayProperties } from "./product-collection";
import { SetupStepName, SetupStepStatus, SetupType } from "containers/admin/settings/merchant-admin-settings";

export enum SchemaTypes {
    Items = "items",
    Doors = "doors",
}

export interface ISchema {
    created_at_ms: string;
    created_by: string;
    display_property: IItemDisplayProperties;
    id: string;
    merchant_id: string;
    name: string;
    revision: string;
}

export interface IMerchantPreference {
    merchant_id: string;
    merchant_v0_uuid: string;
    revision: number;
    default_item_display_property_id: string;
    default_item_display_property_revision: number;
    default_allocation_dimensions: IMutationRef[];
    default_allocation_dimensions_order: string[];
    created_at_ms: number;
    created_by: string;
}

export type IMerchantDefaultAllocationDimensionsPreference = IServerDimensionPreference;

export const updateableMerchantPreferenceFields = {
    default_item_display_property_id: true,
    default_item_display_property_revision: true,
    default_allocation_dimensions: true,
    default_allocation_dimensions_order: true,
};

export const updateableMerchantDefaultAllocationDimensionsPreferenceFields = {
    expanded_columns: true,
    dimensions: true,
};

export const updateableMerchantFeaturePreferenceFields = {
    purchase_orders: true,
    data_export: true,
    external_merchant_key: true,
    editable_size_level_fields: true,
    collection_setting_auto_display: true,
};

export interface IMerchantSharedSettings {
    merchant_id?: string;
    revision?: string;

    market_settings_do_not_auto_display?: boolean;
    custom_attributes_limit?: number;

    created_at_ms?: string;
    created_by?: string;
}

export const MAX_USER_CUSTOM_ATTRIBUTES = 15;

export interface ISetupSteps {
    _id: string;
    created_on: string;
    modified_on: string;
    name: SetupStepName;
    status: SetupStepStatus;
    reference_id: string;
    setup_type: SetupType;
}
